import { Stack, Typography } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import { memo } from 'react';
import { UserAvatar } from 'components/UserAvatar/UserAvatar';
import { UserAccountSummary } from 'utility/types/dataProvider';
import { useTheme } from '@mui/material/styles';

interface UserEmailFieldProps {
  data: UserAccountSummary;
  external?: boolean;
}

export const UserEmailField = memo(({ data, external = false }: UserEmailFieldProps) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        alignItems: 'center',
      }}
    >
      {external && (
        <LaunchIcon
          fontSize="inherit"
          sx={{ color: theme.palette.text.secondary }}
        />
      )}
      <UserAvatar
        user={data}
        size={14}
      />
      <Typography
        data-private
        title={data.email}
      >
        {data.email}
      </Typography>
    </Stack>
  );
});
UserEmailField.displayName = 'UserEmailField';
export default UserEmailField;
